import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          header: 'PAGE_HEADER',
          download_report: 'DOWNLOAD_REPORT',
          change_manager: 'CHANGE_MANAGER_ACTION',
          change_department: 'CHANGE_DEPARTMENT_ACTION',
          change_nnco: 'CHANGE_NNCO_ACTION',
          modal_window: {
            goal_unblock: 'CHANGE_STATUS_GOAL_UNBLOCK',
            goal_block: 'CHANGE_STATUS_GOAL_BLOCK',
            status_title: 'CHANGE_STATUS_GOAL_TITLE',
            status_question: 'CHANGE_STATUS_STATUS_QUESTION',
            status_question_partner: 'CHANGE_STATUS_STATUS_QUESTION_PARTNER',
            answer_yes: 'CHANGE_STATUS_ANSWER_YES',
            answer_no: 'CHANGE_STATUS_ANSWER_NO',
          },
          change_nnco_modals: {
            change_nnco: {
              title: 'CHANGE_NNCO_TITLE',
            },
            confirm_action: {
              question: 'CONFIRM_NNCO_QUESTION',
              ok: 'CONFIRM_NNCO_OK',
              cancel: 'CONFIRM_NNCO_CANCEL',
            },
          },
          change_manager_modals: {
            choose_manager: {
              title: 'CHOOSE_MANAGER_TITLE',
              choose_manager_label: 'CHOOSE_MANAGER_LABEL',
              ok: 'CHOOSE_MANAGER_OK',
              cancel: 'CHOOSE_MANAGER_CANCEL',
            },
            confirm_action: {
              question: 'CONFIRM_QUESTION',
              ok: 'CONFIRM_OK',
              cancel: 'CONFIRM_CANCEL',
            },
          },
          change_department_modals: {
            choose_department: {
              title: 'CHOOSE_DEPARTMENT_TITLE',
              choose_department_label: 'CHOOSE_DEPARTMENT_LABEL',
              ok: 'CHOOSE_DEPARTMENT_OK',
            },
            confirm_action: {
              title: 'CONFIRM_DEPARTMENT_TITLE',
              question: 'CONFIRM_DEPARTMENT_QUESTION',
              ok: 'CONFIRM_DEPARTMENT_OK',
              cancel: 'CONFIRM_DEPARTMENT_CANCEL',
            },
          },
        },
      },
    },
  }));
}
